import permissions, { checkPermissions } from 'config/permissions';

export const customerLinks = [
    {
        order: 0,
        name: 'dashboard',
        icon: 'dashboard.svg',
        title: 'navigation.dashboardTitle',
        permission: "DashboardOperations.dashboard_workWithDashboard",
        show: true,
    },
    {
        order: 1,
        name: 'appeal',
        icon: 'appeals.svg',
        title: 'navigation.appealsTitle',
        permission: "AppealOperations.view_appeal",
        show: true,
    },
    {
        order: 2,
        name: 'orders',
        icon: 'order.svg',
        title: 'navigation.orders',
        permission: "OrderOperations.view_order",
        show: true,
    },
    {
        order: 3,
        name: 'services',
        icon: 'service.svg',
        title: 'navigation.services',
        permission: "ServiceOperations.view_service",
        show: true,
    },
    {
        order: 4,
        name: 'knowledge_base',
        icon: 'knowledge_base.svg',
        title: 'navigation.knowledgeBase',
        permission: "UserOperations.action_clientPartViewKnowledgeBase",
        show: true,
    },
    {
        order: 5,
        name: 'specification',
        icon: 'specification.svg',
        title: 'navigation.specification',
        permission: "CliSpecOperations.view_Spec",
        show: true,
    },
    {
        order: 6,
        name: 'issue',
        icon: 'issue.svg',
        title: 'navigation.issue',
        permission: "AppealOperations.action_viewGlobalProblems",
        show: true,
    },
    {
        order: 7,
        name: 'calendar',
        icon: 'calendar.svg',
        title: 'navigation.calendar',
        permission: "CalendarOperations.view_calendar",
        show: true,
    },
    {
        order: 8,
        name: 'resources',
        icon: 'resource.svg',
        title: 'navigation.resources',
        permission: "ServiceOperations.view_resource",
        show: true,
    },
    {
        order: 9,
        name: 'customers',
        icon: 'customers.svg',
        title: 'navigation.customersTitle',
        permission: "SearchOperations.search_customer",
        show: true,
    },
    {
        order: 10,
        name: 'bunits',
        icon: 'bunits.svg',
        title: 'navigation.bunits',
        permission: "BuOperations.view_bu",
        show: true,
    },
    {
        order: 11,
        name: 'documents',
        icon: 'documents.svg',
        title: 'navigation.documents',
        permission: "DocumentOperations.view_service",
        show: true,
    },
];

export const adminLinks = [{
    order: 0,
    name: 'settings',
    icon: 'settings.svg',
    // link: '/settings/controlUsers/domains',
    // link: '/settings',
    permission: "AdminGrantOperations.view_permissions",
    show: true,
}];

export const settingsNavigation = (staticBlocks) => {
    const controlUsers = {
        name: 'controlUsers',
        route: '/settings/controlUsers',
        id: 1,
        exact: true,
        children: [
            {
                name: 'domains',
                route: '/settings/controlUsers/domains',
                id: 101,
            },
            {
                name: 'groups',
                route: '/settings/controlUsers/groups',
                id: 102,
            },
            {
                name: 'users',
                route: '/settings/controlUsers/users',
                id: 103,
            },
            {
                name: 'roles',
                route: '/settings/controlUsers/roles',
                id: 104,
            },
            {
                name: 'bu',
                route: '/settings/controlUsers/bu',
                id: 105,
            },
        ],
    };


    // translations sysCode=CRM|SDSPORTAL|null   
    const translations_CRM = {
        name: 'translations_CRM',
        route: '/settings/translations_CRM/',
        id: 2,
        exact: true,
        children: [
            {
                name: 'uk',
                route: '/settings/translations_CRM/uk',
                id: 201,
            },
            {
                name: 'en',
                route: '/settings/translations_CRM/en',
                id: 202,
            },
        ],
    };

    const translations_SDSPORTAL = {
        name: 'translations_SDSPORTAL',
        route: '/settings/translations_SDSPORTAL/',
        id: 3,
        exact: true,
        children: [
            {
                name: 'uk',
                route: '/settings/translations_SDSPORTAL/uk',
                id: 301,
            },
            {
                name: 'en',
                route: '/settings/translations_SDSPORTAL/en',
                id: 302,
            },
            {
                name: 'pl',
                route: '/settings/translations_SDSPORTAL/pl',
                id: 303,
            },
        ],
    };

    const links = [];
    links.push(controlUsers);

    const isRoleAdmin = checkPermissions(permissions.AdminOperations.role_admin);

    if (isRoleAdmin) {
        // links.push(translations);
        links.push(translations_CRM);
        links.push(translations_SDSPORTAL);

    }

    const isManageStaticBlocks = checkPermissions(permissions.StaticParamOperations.action_manageBlockParam);


    if (isManageStaticBlocks && staticBlocks) {
        const blocks = {
            name: 'blocks',
            route: '/settings/blocks/',
            id: 4,
            exact: true,
            children: staticBlocks.map((block, index) => {
                return {
                    name: block.name,
                    route: `/settings/blocks/${block.code}`,
                    id: 401 + index,
                    isTranslated: true,
                };
            }),
        };
        links.push(blocks);
    }

    return links;
};
